export function getRoles(user) {
    const rawRoles = Array.isArray(user?.roles) ? user.roles : [];
    const legacyRole = user?.role;

    const out = [];
    const seen = new Set();

    for (const role of rawRoles) {
        const key = String(role || "").trim().toLowerCase();
        if (!key || seen.has(key)) continue;

        seen.add(key);
        out.push(key);
    }

    if (legacyRole) {
        const key = String(legacyRole || "").trim().toLowerCase();
        if (key && !seen.has(key)) {
            seen.add(key);
            out.push(key);
        }
    }

    if (!out.length && user) {
        out.push("user");
    }

    if (seen.has("orga") && !seen.has("user")) {
        out.unshift("user");
    }

    return out;
}

export function hasRole(user, role) {
    const wanted = String(role || "").trim().toLowerCase();
    if (!wanted) return false;

    return getRoles(user).includes(wanted);
}

export function roleLabel(role) {
    const key = String(role || "").trim().toLowerCase();

    if (key === "admin") return "Admin";
    if (key === "orga") return "Orga";
    if (key === "reko") return "ReKo";
    if (key === "reko_lead") return "ReKo Lead";
    if (key === "user") return "User";

    return role;
}

export function normalizeUser(user) {
    if (!user) return null;

    const roles = getRoles(user);

    return {
        ...user,
        role: user.role || roles[0] || "user",
        roles,
    };
}
